import { localisedValue } from "utils"

const countryTransformer = response => {
  return response.map(e => ({
    ...e,
    key: e.id,
    label: localisedValue({ object: e, key: "name" }),
    value: e.id.toString(),
  }))
}

export default countryTransformer
